<template>
  <div v-if="!$can('view', 'original domain connect')">
    <resource-create-wrapper
      :need-modal="showModal"
      v-if="$route.params.subdomain"
      :title="$t('resources.domains.create_subdomain_title')"
      ref="createWrapper">
      <template #actions>
        <v-btn @click="cancelButtonHandler" class="ml-auto cancel__btn" color="primary" outlined>
          {{ $t("generic.buttons.cancel") }}
        </v-btn>
        <v-btn @click="save('subdomainForm')" :loading="loading" color="primary">
          {{ $t("generic.buttons.next") }}
        </v-btn>
      </template>
      <SubdomainForm @loading="handleLoading" @isDirtyForm="isDirtyForm" ref="subdomainForm"> </SubdomainForm>
    </resource-create-wrapper>
    <resource-create-wrapper :need-modal="showModal" v-else :title="$t('resources.domains.create')" ref="createWrapper">
      <template #actions>
        <v-btn @click="cancelButtonHandler" class="ml-auto cancel__btn" color="primary" outlined>
          {{ $t("generic.buttons.cancel") }}
        </v-btn>
        <v-btn @click="save('newDomainForm')" :loading="loading" color="primary">
          {{ $t("generic.buttons.next") }}
        </v-btn>
      </template>
      <NewDomainForm
        @loading="handleLoading"
        @isDirtyForm="isDirtyForm"
        @disableRedirect="disableRedirect"
        ref="newDomainForm"></NewDomainForm>
    </resource-create-wrapper>
  </div>
  <div v-else>
    <resource-create-wrapper
      :title="$t('resources.domains.create')"
      :need-modal="showModal"
      :show-bottom-actions="true"
      @saveAction="$refs['domainForm'].submit()"
      ref="createWrapper">
      <DomainForm @isDirtyForm="isDirtyForm" ref="domainForm"></DomainForm>
    </resource-create-wrapper>
  </div>
</template>

<script>
  import DomainForm from "@/components/forms/DomainForm";
  import SubdomainForm from "@/components/forms/SubdomainForm.vue";
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import NewDomainForm from "@/components/forms/NewDomainForm.vue";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      DomainForm,
      ResourceCreateWrapper,
      SubdomainForm,
      NewDomainForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
        default: "",
      },
      title: {
        type: String,
        required: true,
      },
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        showModal: false,
        loading: false,
      };
    },
    methods: {
      handleLoading(value) {
        this.loading = value;
      },
      save(ref) {
        this.showModal = false;
        this.$refs[ref].submit();
      },
      disableRedirect(value) {
        this.showModal = value;
      },
      cancelButtonHandler() {
        this.$refs.createWrapper.onCancel();
      },
    },
  };
</script>
